import { features } from 'helpers/constants'
import React from "react"
import {t} from "helpers/language"

export const skill = {
  key: "IMPORT_PRICE_LISTS",
  group: 'pricelists',
  label: t("Import your price lists"),
  desc: t("Populate your price lists to get quoting"),
  location: '/price-lists/import',
  feature: features.PRICE_LISTS_LICENCE,
  steps: [
    {
      target: '.select-your-csv-import-file > button',
      content: <div>To begin, click on <i>SELECT YOUR CSV IMPORT FILE</i></div>,
    },
    {
      target: '.priceListImportStepper-autoDetectButton',
      content: <div>Click on the <i>Auto-Detect Columns</i> button to automatically find all the columns in your csv file.</div>,
      auto: true,
    },
    {
      target: '.priceListImportPivotTable-container',
      content: <div>We have detected the columns based on your CSV file and have matched them against your parts.</div>,
      actions: [
        {
          label: 'Next',
          primary: true,
          flat: true,
          type: 'next',
        },
      ],
    },
    {
      target: '.priceListImportStepper-next',
      content: <div>Click on <i>NEXT</i> to select your price list</div>,
      auto: true,
    },
    {
      target: '.priceListImportStepper-price-list-section',
      content: <div>Search for an existing price list or create a new one.</div>,
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: 'Next',
          primary: true,
          flat: true,
          type: 'next',
        },
      ],
    },
    {
      target: '.priceListImportStepper-import',
      content: <div>Finally you can click <i>IMPORT</i> to import your parts.</div>,
      auto: true,
    },
  ],
}

export default skill
